import React from "react";
import "./BudgetView.css";

export const BudgetView = ({ budgetEstimates }) => {
  return (
    <div className="budget-view">
      <div className="budget-header">
        <h3>Budget Summary</h3>
      </div>
      {budgetEstimates && budgetEstimates.length > 0 && (
        <div className="monthly-estimates">
          <h3>Monthly Budget Estimates</h3>
          <div className="budget-table-container">
            <table>
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Monthly Estimate</th>
                </tr>
              </thead>
              <tbody>
                {budgetEstimates.map(({ category, monthlyEstimate }) => (
                  <tr key={category}>
                    <td>{category}</td>
                    <td className="amount">
                      {new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                      }).format(monthlyEstimate)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};
